// src/components/ApartmentList.js
import React from 'react';
import ApartmentCard from './ApartmentCard';
import { FaArrowLeft } from "react-icons/fa";
import { FaHome } from "react-icons/fa";

const ApartmentList = ({ apartments, onSelectApartment, onBackToChat }) => {
  const sorted = [...(apartments ?? [])].sort((a, b) => {
    const a3d = a?.fullDetailsForPanel?.glbModelUrl ? 1 : 0;
    const b3d = b?.fullDetailsForPanel?.glbModelUrl ? 1 : 0;
    return b3d - a3d;           // put 3D (1) above non-3D (0)
  });

  if (!sorted || sorted.length === 0) {
    // Optionally, show a message if no apartments are found,
    // especially if this view takes the main space.
    return (
      <div className="flex items-center justify-center h-full text-slate-400">
        <p>Aucune propriété à afficher pour le moment.</p>
      </div>
    );
  }

  return (
    // This div takes the full height allocated by its parent in AssistantScreen
    // and uses flex column layout. Added padding.
    <div className="w-full h-full flex flex-col px-4 pt-4">

       <div className="sticky top-0 z-10 mb-3 flex items-center">
        <button onClick={onBackToChat} className="p-2 rounded-full hover:bg-gray-light text-text-dark">
          <FaArrowLeft className="text-lg" /> {/* Back button with arrow icon */}
        </button>
        <span className="inline-flex items-center gap-1 bg-accent-primary backdrop-blur px-3 py-1.5 rounded-full text-md font-semibold text-white shadow">
         <FaHome className="text-[20px] text-white" />
          Propriétés

        </span>
      </div>
      {/* This div for cards will take the remaining space and allow internal y-scrolling */}
      {/* Added space-y-4 for spacing between cards and custom-scrollbar class */}
      <div
        className="min-h-0 flex-1 overflow-y-auto flex flex-col gap-4 pr-2 custom-scrollbar"
      >
        {sorted.map((apt) => (
          <ApartmentCard
            key={apt.id} // Ensure your apartment objects have a unique 'id'
            listing={apt}
            onSelect={() => onSelectApartment(apt)}
            // No more horizontal scroll specific props needed for the card itself
          />
        ))}
      </div>
      {/* Custom scrollbar styling - adapted for vertical scroll */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px; /* For vertical scrollbar */
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #0f172a; /* slate-900, or transparent if parent bg is desired */
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #334155; /* slate-700 */
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background-color: #475569; /* slate-600 */
        }
        
        /* For Firefox */
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: #334155 #0f172a; /* thumb track */
        }
      `}</style>
    </div>
  );
};

export default ApartmentList;
